export function formatDate(dateString: string): string {
  if(!dateString) {
    return '-'
  }

  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  };

  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  const splitDate = formattedDate.split(" ");

  const day = splitDate[1].split(",")[0];
  const month = splitDate[0];
  const hour = splitDate[2].split(":")[0];
  const minute = splitDate[2].split(":")[1];

  return `${day} ${month} ${hour}.${minute}`;
}